<template>
  <div class="deposit-ui">

    <!-- TOP SELECTORS -->
    <div class="top-selectors">

      <!-- COIN -->
<div class="select-card">
  <span class="label">Currency</span>

  <div class="custom-select" @click="toggleCoinDropdown">
    <span>{{ selectedCoinLabel }}</span>
    <i class="arrow">▾</i>
  </div>

  <div class="dropdown" v-if="coinDropdownOpen">
    <div
      class="option"
      v-for="coin in coins"
      :key="coin.symbol"
      @click="selectCoin(coin.symbol)"
    >
      {{ coin.symbol }}
    </div>
  </div>
</div>



   <!-- NETWORK -->
<div class="select-card">
  <span class="label">Network</span>

  <div
    class="custom-select"
    @click="toggleNetworkDropdown"
  >
    <span>
      {{
        selectedNetwork
          ? (networks.find(n => n.networkName === selectedNetwork)?.network === 'Bitcoin'
              ? 'Native'
              : networks.find(n => n.networkName === selectedNetwork)?.network)
          : 'Select network'
      }}
    </span>
    <i class="arrow">▾</i>
  </div>

  <div
    class="dropdown network-dropdown"
    v-if="networkDropdownOpen"
  >
    <div
      class="option"
      v-for="net in networks"
      :key="net.networkName"
      :class="{ active: net.networkName === selectedNetwork }"
      @click="selectNetwork(net.networkName)"
    >
      {{ net.network === 'Bitcoin' ? 'Native' : net.network }}
    </div>
  </div>
</div>


    </div>

    <!-- ADDRESS + QR -->
    <div v-if="address" class="address-row">

      <!-- ADDRESS -->
      <div class="address-card">
        <span class="label">
          Your {{ selectedCoin }} deposit address
        </span>

        <div class="address-line">
          <span class="addr">{{ shortAddress }}</span>
          <button class="copy" @click="copy">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#B3BEC1" d="M6.6 11.397c0-2.726 0-4.089.843-4.936c.844-.847 2.201-.847 4.917-.847h2.88c2.715 0 4.073 0 4.916.847c.844.847.844 2.21.844 4.936v4.82c0 2.726 0 4.089-.844 4.936c-.843.847-2.201.847-4.916.847h-2.88c-2.716 0-4.073 0-4.917-.847s-.843-2.21-.843-4.936z"/><path fill="#B3BEC1" d="M4.172 3.172C3 4.343 3 6.229 3 10v2c0 3.771 0 5.657 1.172 6.828c.617.618 1.433.91 2.62 1.048c-.192-.84-.192-1.996-.192-3.66v-4.819c0-2.726 0-4.089.843-4.936c.844-.847 2.201-.847 4.917-.847h2.88c1.652 0 2.8 0 3.638.19c-.138-1.193-.43-2.012-1.05-2.632C16.657 2 14.771 2 11 2S5.343 2 4.172 3.172" opacity="0.3"/></svg>
          </button>
        </div>

        <div class="min">
          The min deposit amount
          <b>{{ depositMin }} {{ selectedCoin }}</b>
        </div>

        <div class="info">
          ℹ Send only {{ selectedCoin }} to this address
        </div>
      </div>

      <!-- QR -->
      <div class="qr-card">
        <QRCode :value="address" :options="{ width: 120 }" />
      </div>

    </div>

    <!-- LOADING -->
    <div v-if="loading" class="loading">
      Generating address...
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import QRCode from '@/components/QRCode'

export default {
  name: 'DepositCryptoModal',

  components: { QRCode },

  data() {
    return {
      // mevcut
      selectedCoin: null,
      selectedNetwork: null,
       networkDropdownOpen: false,
      address: null,
      depositMin: null,
      loading: false,

      // 🔽 YENİ
      coinDropdownOpen: false
    }
  },

  computed: {
    ...mapGetters('crypto', ['coins', 'getCoin', 'getNetworks']),
    ...mapGetters(['authUser']),

    networks() {
      if (!this.selectedCoin) return []
      return this.getNetworks(this.selectedCoin)
    },

    shortAddress() {
      if (!this.address) return ''
      return `${this.address.slice(0, 6)}...${this.address.slice(-5)}`
    },

    // 🔽 Seçili coin label (UI için)
    selectedCoinLabel() {
      return this.selectedCoin || 'Select currency'
    }
  },

  async mounted() {
    await this.fetchCryptoOptions()

    if (this.coins.length) {
      this.selectCoin(this.coins[0].symbol)
    }
  },

  watch: {
    selectedCoin() {
      this.reset()
      this.selectedNetwork = this.networks[0]?.networkName

      if (this.selectedNetwork) {
        this.createAddress()
      }
    },

    selectedNetwork() {
      this.reset()

      if (this.selectedNetwork) {
        this.createAddress()
      }
    }
  },

  methods: {
    ...mapActions('crypto', [
      'fetchCryptoOptions',
      'getStaticAddress'
    ]),

    ...mapActions(['notificationShow']),

    // 🔽 CUSTOM DROPDOWN SELECT
    selectCoin(symbol) {
      if (this.selectedCoin === symbol) return

      this.selectedCoin = symbol
      this.coinDropdownOpen = false
    },

    toggleCoinDropdown() {
      this.coinDropdownOpen = !this.coinDropdownOpen
    },

    closeCoinDropdown() {
      this.coinDropdownOpen = false
    },

    toggleNetworkDropdown() {
  if (!this.networks.length) return
  this.networkDropdownOpen = !this.networkDropdownOpen
},

selectNetwork(networkName) {
  if (this.selectedNetwork === networkName) return

  this.selectedNetwork = networkName
  this.networkDropdownOpen = false
},

    reset() {
      this.address = null
      this.depositMin = null
    },

    async createAddress() {
      if (!this.authUser?.user?._id) return
      if (!this.selectedCoin || !this.selectedNetwork) return

      this.loading = true

      try {
        const res = await this.getStaticAddress({
          coinType: this.selectedCoin,
          network: this.selectedNetwork
        })

        this.address = res.address
        this.depositMin = res.depositMin
      } catch (err) {
        this.notificationShow.error(err.message || 'Address error')
      } finally {
        this.loading = false
      }
    },

    copy() {
      if (!this.address) return
      navigator.clipboard.writeText(this.address)
      this.notificationShow.success('Address copied')
    }
  }
}
</script>


<style scoped>
.deposit-ui {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 25px;
}

/* TOP */
.top-selectors {
  display: grid;
  grid-template-columns: 1fr 10fr;
  gap: 14px;
}

.select-card {
  background: var(--background2);
  border-radius: 14px;
  padding: 12px 14px;
}

.select-card .label {
  font-size: 12px;
  color: #fff;
}

.select-card select {
  margin-top: 6px;
  width: 100%;
  background: transparent;
  border: none;
  color: #fff;
  font-weight: 600;
  outline: none;
}

/* ADDRESS */
.address-row {
  display: grid;
  grid-template-columns: 1fr 140px;
  gap: 14px;
}

.address-card {
  background: var(--background2);
  border-radius: 16px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.address-card .label {
  font-size: 12px;
  color: #8fa6bd;
}

.address-line {
  background: var(--background);
  border-radius: 10px;
  padding: 10px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.addr {
  font-family: monospace;
  font-size: 14px;
  color: #fff;
}

.copy {
  background: none;
  border: none;
  color: #9fb3c8;
  cursor: pointer;
}

.min {
  font-size: 12px;
  color: #9fb3c8;
}

.info {
  background: rgba(240,195,109,.08);
  color: #f0c36d;
  padding: 8px 10px;
  font-size: 12px;
  border-radius: 10px;
}

/* QR */
.qr-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading {
  text-align: center;
  font-size: 13px;
  color: #9fb3c8;
}
.select-card {
  position: relative;
  font-family: "Rubik", sans-serif;
    font-weight: bold;
}
 

.dropdown {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  width: 100%;

  background: var(--background);
  border-radius: 12px;

  box-shadow: 0 10px 30px rgba(0,0,0,.5);

  /* 🔽 SCROLL */
  max-height: 160px;
  overflow-y: auto;

  z-index: 10;
}
.dropdown::-webkit-scrollbar {
  width: 8px;
}

.dropdown::-webkit-scrollbar-track {
  background: rgba(255,255,255,0.05);
  border-radius: 8px;
}

.dropdown::-webkit-scrollbar-thumb {
  background: var(--active-button);
  border-radius: 8px;
}



.option {
  padding: 14px 16px;
  color: #fff;
  font-family: "Rubik", sans-serif;
    font-weight: bold;
}
 

</style>
